import { PublicClientApplication } from "@azure/msal-browser";
export interface IHeaderProps {
  header: IHeader;
}

export interface IHeader {
  logoSrc: string;
  userName: string;
  userRole: string;
  userAvatar: string;
}

export interface INavigationData {
  cANavigationCollection: {
    items: NavigationItems[];
  };
}

export interface NavigationItems {
  title: string;
  url: string;
  isExternal: boolean;
  sortOrder: number;
  active: boolean;
  types: string;
   dashboard: {
    items: {
      _system: {
        id: string;
      };
    }[];
  };
}

export interface AcademyItem extends ICommonInfo {
  _system: system;
  description: string;
  regDeadline: Date;
  eventDate: Date;
  eventTime: string;
  dashboard: {
    items: Dashboard[];
  };
}

export interface KeyDateDashboardItem {
  _system: {
    id: string;
  };
  displayName: string;
  dashboardRegion: string;
}

export interface DashboardItem {
  displayName: string;
  quickLinksOrder: string;
  keyDatesDeadlinesOrder: string;
  announcementsOrder: string;
  academyCalendarOrder: string;
  keyContactInformationOrder: string;
  dashboardCodeName: string;
}

export interface RoleItem {
  roleDisplayName: string;
}

export interface IAcademyData {
  cAAcademyCollection: {
    items: AcademyItem[];
  };
}

export interface AnnouncementDetails extends ICommonInfo {
  message: string;
  _system: system;
  imageContentHub: IAccordionImageContentHub;
  dashboard: {
    items: KeyDateDashboardItem[];
  };
}

export interface AnnouncementItems {
  type: string;
  headline: string;
  description: string;
  button_URL: string;
  button_Text: string;
  deadline: Date;
  posted_Date: string;
  end_Date: Date;
  feature: boolean;
  image: image[];
  dashboard: {
    items: DashboardItem[];
  };
}

export interface IAnnouncementDetailsData {
  cAAnnouncementsCollection: {
    items: AnnouncementDetails[];
  };
}

export interface IAnnouncementData {
  cAEventsNoticeCollection: {
    items: AnnouncementItems[];
  };
}
export interface IKeyDateDeadlineData {
  cAKeyDatesCollection: {
    items: KeyDates[];
  };
}

export interface EventNotice {
  type: string;
  headline: string;
  description: string;
  buttonUrl: string;
  buttonText: string;
  deadline: Date;
  postedDate: Date;
  endDate: Date;
  feature: Boolean;
  dashboard: {
    items: KeyDateDashboardItem[];
  };
}

export interface KeyDatesDeadlineProps {
  cAEventsNoticeCollection: {
    totalCount: number;
    items: EventNotice[];
  };
}

export interface system {
  firstPublished: Date;
  lastPublished: Date;
  id: string;
}

export interface KeyContactInformationProps {
  name: string;
  title: string;
  email: string;
  phoneNumber: number;
  _system: system;
  dashboard: {
    items: KeyDateDashboardItem[];
  };
}

export interface IKeyContactInformation {
  cAContactInfoCollection: {
    items: KeyContactInformationProps[];
  };
}

// Dashboard
export interface IResourceItem {
  title: string;
  shortDescription: string;
  buttonURL: string;
  buttonText: string;
  feature: boolean;
  detailPage: string;
}

export interface IGroupNameData {
  title: string;
  buttonText: string;
  resources: {
    items: IResourceItem[];
  };
}

export interface IDashboardData {
  displayName: string;
  group: {
    items: IGroupNameData[];
  };
}

export interface IRolesData {
  roleValue: string;
  roledisplayName: string;
  dashboard: {
    items: IDashboardData[];
  };
}

export interface IResourceData {
  cARolesCollection: {
    items: IRolesData[];
  };
}

// updated
// Interface for the data returned by the ROLES_QUERY
export interface Role {
  _system: system;
  roleValue: string;
  roleDisplayName: string;
  dashboard: {
    items: Dashboard[];
  };
}

export interface ApiRole {
  rolesValue: string;
  rolesDisplayName: string;
  isAdministrator: boolean
  dashboardID: string;
  dashBoardDisplayName: string;
}


export interface RolesData {
  cARolesCollection: {
    items: Role[];
  };
}

// Interface for the data returned by the DASHBOARD_RECORD_QUERY
export interface Dashboard {
  _system: system;
  displayName: string;
  dashboardRegion: string;
  quickLinksOrder: string;
  keyDatesDeadlinesOrder: string;
  announcementsOrder: string;
  academyCalendarOrder: string;
  keyContactInformationOrder: string;
  academyCalendarTitle: string;
  priority: number;
}

export interface RoleWithDashboard extends Role {
  dashboard: {
    items: Dashboard[];
  };
}

export interface DashboardData {
  cADashboardCollection: {
    items: Dashboard[];
  };
}

// Interface for the data returned by the GROUP_RECORD_QUERY
export interface Group {
  _system: system;
  title: string;
  dashboard: {
    items: Dashboard[];
  };
  resourceType: string;
  feature: boolean;
  accordionOpen: boolean;
  buttonText: string;
  buttonUrl: string;
  orderBy: number;
  accordionImageContentHub: IAccordionImageContentHub;
}

export interface IAccordionImageContentHub {
  items: IAccordionImageContentHubItem[];
}

export interface IAccordionImageContentHubItem {
  contentFile: IContentFile;
}

export interface IContentFile {
  name: string;
  path: string;
  fileSize: number;
  fileType: string;
  width: number;
  height: number;
}

export interface image {
  fileName: string;
  path: string;
  fileSize: string;
  fileType: string;
  width: string;
  height: string;
}

export interface GroupData {
  cAGroupNameCollection: {
    items: Group[];
  };
}

// Interface for the data returned by the RESOURCE_RECORD_QUERY
export interface ResourceCommonData {
  _system: system;
  title: string;
  shortDescription: string;
  buttonURL: string;
  buttonText: string;
  feature: boolean;
  aliasPath: string;
  imageContentHub: IAccordionImageContentHub;
}

export interface ResourceAllData extends ResourceCommonData {
  resourceType: string;
  groupName: string;
}

export interface Resource extends ResourceCommonData {
  resourceType: {
    items: resourceType[];
  };
  groupName: {
    items: Group[];
  };
}

export interface IGroupProps {
  groupRecord: Group[];
  resourceAllRecord: Resource[];
  resourceTypeId: string;
}

export interface resourceType {
  _system: system;
  title: string;
  imageContentHub: IAccordionImageContentHub;
}

export interface IResourceData {
  cAResourceTypeCollection: {
    items: resourceType[];
  };
}

export interface ResourceGroup {
  groupCodeName: string;
  title: string;
  feature: boolean;
  buttonText: string;
  buttonUrl: string;
  orderBy: number;
  _system: {
    id: string;
  };
}

export interface IResourceCardListProps {
  group: Group;
  resourceTypeId?: string;
  resourceType?: resourceType;
  expandAll?: boolean;
  collapseAll?: boolean;
  showExpandCollapse?: (showExpandCollapse:boolean) => void;
}

export interface IResourceCardProps {
  Resoursecard: Resource;
}

export interface ResourcesData {
  cAResourcesCollection: {
    items: ResourceAllData[];
  };
}

export interface errorModel {
  type: string;
  error: string;
  eventCode: string;
  source: string;
}
export interface EventNoticeDetails extends AnnouncementItems { }

// Interface for the data returned by the RESOURCE_ASSET_QUERY
export interface IAssetsCategoryData {
  cAAssetCategoryCollection: {
    items: AssetsCategoryItem[];
  };
}

export interface AssetsCategoryItem {
  categoryName: string;
  orderBy: number;
  _system: system;
}

//Interface for the data returned by the Resource_Folder_QUERY
export interface IResourceFolderData {
  cAResourceFolderCollection: {
    items: ResourceFolderItem[];
  };
}

export interface ResourceFolderItem {
  folderName: string;
  orderBy: number;
  _system: system;
}

export interface CampaignItemsResourceType {
  resourceTypeId: string;
  resourceTypeTitle: string;
  resourceTypeImage: string;
}

export interface CampaignItemsRecords {
  resourceId: string;
  resourceTitle: string;
  resourceDesc: string;
  resourceImage: string;
  resourceTypeId: string;
}

// Interface for the data returned by the Resource_Assets_QUERY
export interface IResourceAssetsData {
  cAResourceAssetCollection: {
    items: ResourceAssetItem[];
  };
}

export interface item {
  _system: system;
}

export interface ResourceAssetSystem {
  id: string;
  contentType: string;
}

export interface ResourceAssetContentFile {
  name: string;
  path: string;
  fileSize: number;
  fileType: string;
  width: number;
  height: number;
}

export interface FileItem {
  fileName: string;
  fileText?: string;
  fileid: string;
  filePath: string;
  fileType: string;
  externalURL?: string;
  safeFileName?: string;
  link?: string;
}

export interface ResourceAssetImageContentHubItem {
  contentFile: ResourceAssetContentFile;
}

export interface ResourceAssetImageContentHub {
  items: ResourceAssetImageContentHubItem[];
}

export interface ResourceAssetItem {
  _system: ResourceAssetSystem;
  title: string;
  externalURL: string;
  imageContentHub: ResourceAssetImageContentHub;
  resource: string;
  resourceFolderName: string;
  assetCategory: string;
}

// Interfce for the data returned by the HEADER_QUERY
export interface IContentFile {
  name: string;
  path: string;
  fileSize: number;
  fileType: string;
  width: number;
  height: number;
}

export interface IContentHubItem {
  contentFile: IContentFile;
}

export interface IContentHub {
  items: IContentHubItem[];
}

export interface MasterDataItem {
  imageContentHub: IContentHub;
  imageContentHubFooterLogo: IContentHub;
  footerLogoUrl: string;
  footerText: string;
  imageContnetHubFooterContentLogo: IContentHub;
  facebookNavigation: string;
  youtubeNavigation: string;
  instagramNavigation: string;
  linkedInNavigation: string;
}

export interface IMasterData {
  cAMasterDataCollection: {
    items: MasterDataItem[];
  };
}

// Common Interfaces Academy, Announcments & Key Dates
export interface ICommonInfo {
  headline: string;
  buttonUrl: string;
  buttonText: string;
  postedDate: Date;
  endDate: Date;
  feature: boolean;
}

// Interface KeyDates Content Types
export interface KeyDates extends ICommonInfo {
  description: string;
  deadline: Date;
  _system: system;
  dashboard: {
    items: KeyDateDashboardItem[];
  };
}

export interface Asset {
  fileName: string;
  path: string;
  fileType: string;
  resource: Resource[];
}

export interface ContentItem {
  contentFile: {
    name: string;
    path: string;
    fileSize: number;
    fileType: string;
    width: number | null;
    height: number | null;
  };
}

export interface ResourceTypeItem {
  title: string;
  _system: {
    id: string;
  };
}

export interface assetCategory {
  items: {
    categoryName: string;
  };
}

export interface IApp {
  instance: PublicClientApplication;
}
export interface Result {
  id: string;
  title?: string; // Make title optional
  headline?: string; // Add headline field
  description?: string; // Make description optional
  message?: string; // Add message field
  shortDescription?: string; // Add shortDescription field
  type: string; // Add type field
  imageContentHub?: {
    items: ContentItem[];
  };
  assetCategory?: assetCategory;
  hasAsset?: boolean; // Add hasAsset property
  __typename: string; // Add __typename field for content type
  _system?: {
    contentType: string; // Add contentType field
    lastPublished: string;
    id: string; // Add id field to _system
  }; // Add _system field for lastPublished date
  groupName?: string; // Change groupName to string
  resource?: string; // Change resource to string
  resourceTitle?: string; // Add resourceTitle field
  resourceGroupName?: string; // Add resourceGroupName field
  resourceType?: {
    items: ResourceTypeItem[];
  }; // Add resourceType field for resources
  buttonURL?: string; // Added buttonURL property
  aliasPath?: string; // Added aliasPath property
}

export const fileTypeIcons: { [key: string]: string } = {
  "application/pdf": "fa-kit fa-pdf-o",
  "application/msword": "fa-kit fa-file-word",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "fa-kit fa-file-word",
  "application/vnd.ms-excel": "fa-kit fa-file-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    "fa-kit fa-file-excel",
  "image/jpeg": "fa-kit fa-file-image",
  "image/png": "fa-kit fa-file-image",
  "text/plain": "fa-kit fa-file-alt",
  "application/zip": "fa-kit fa-file-archive",
  // Add more mappings as needed
};

export const previewFileTypes: { [key: string]: string } = {
  "application/pdf": "pdf",
  // "application/msword": "doc",
  // "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
  //   "doc",
  // "application/vnd.ms-excel": "excel",
  // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "excel",
  "image/jpeg": "image",
  "image/jpg": "image",
  "image/png": "image",
  "image/webp": "image",
  "image/bmp": "image",
  "video/mp4": "video",
  "audio/mpeg": "audio",
  "audio/wav": "audio",
  ".pdf": "pdf",
  ".jpeg": "image",
  ".jpg": "image",
  ".png": "image",
  ".webp": "image",
  ".bmp": "image",
  ".mpeg": "audio",
  ".wav": "audio",
  ".mp4": "video",
  ".mp3": "audio",
  // Add more mappings as needed
};
export const mimeTypes: { [key: string]: string } = {
  ".pdf": "application/pdf",
  ".doc": "application/msword",
  ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".ppt": "application/vnd.ms-powerpoint",
  ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpg",
  ".png": "image/png",
  ".webp": "image/webp",
  ".bmp": "image/bmp",
  ".mp4": "video/mp4",
  ".mpeg": "audio/mpeg",
  ".wav": "audio/wav",
  ".zip": "application/zip",
  ".zipx": "application/x-zip-compressed",
  ".7z": "application/x-7z-compressed",
  ".tar": "application/x-tar",
  ".rar": "application/x-rar-compressed",
  ".json": "application/json",
  ".txt": "text/plain",
  ".csv": "text/csv",
  ".xml": "application/xml",
  '.mp3': 'audio/mpeg',

  // Add more mappings as needed
};
export interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
}
export interface MyLinksGroup {
  accordionOpen?: boolean;
  myLinksGroupName: string;
}

export interface MyLink {
  title: string;
  myLinksGroupName: string; // group name as string
  url: string;
  accordionOpen?: boolean;
}

export interface MyLinksGroupCollection {
  items: MyLinksGroup[];
}
export interface ResourceApiAsset {
  assetName: string;
  assetID: string;
  imageContentHub: {
    items: {
      contentFile: {
        name: string;
        shortDescription: string;
        path: string;
        fileSize: number;
        fileType: string;
        width: number;
        height: number;
        identifier: string;
        extension?: string;
      };
      _system: {
        id: string;
      };
    }[];
  };
  externalURL: string;
}

export interface ResourceApiCategory {
  categoryName: string;
  categoryID: string;
  orderBy: number;
  assets: ResourceApiAsset[];
}

export interface ResourceApiFolder {
  folderName: string;
  folderID: string;
  categories: ResourceApiCategory[];
}

export interface ResourceApiResponse extends Array<ResourceApiFolder> { }

export interface Document {
  documentFileName: string;
  documentId: string;
  title: string;
  description?: string;
  documentFolder: string;
  documentCategory: string;
  retailerSpecificDocument?: boolean;
  RetailerLocation?: string;
  RetailerNames?: string;
  documentLastUpdated: Date;
  documentCreatedDate: Date;
  documentFileExtension: string;
  link?: string;
}
export interface Cursor {
  self: string;
  next: string | null;
  previous: string | null;
}
export interface DocumentsResponse {
  items: GroupedDocuments[];
  cursor: Cursor;
  totalCount: number;
}
export interface GroupedDocuments {
  folderName: string;
  accordionOpen?: boolean;
  categories: {
    categoryName: string;
    accordianOpen?: boolean;
    documents: Document[];
  }[];
}

// Localization API Response Interface
export interface LocalizationResponse {
  localizations: Record<string, string>;
  count: number;
}
